import { __assign } from "tslib";
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import { Simulate } from 'react-dom/test-utils';
import * as React from 'react';
import { DeprecatedMultiSelect } from './multi-select';
export var createMultiSelectLegacyDriver = function (element) {
    var baseDriver = getLegacyBaseDriverFromWrapper(element, '.multi-select', DeprecatedMultiSelect.name);
    var selectInput = baseDriver.find('.Select-input input').elem;
    var openSelection = function () { return Simulate.focus(selectInput); };
    var optionAtIndex = function (index) { return baseDriver
        .findAll('.Select-option').get(index); };
    return {
        openSelection: function () { return openSelection(); },
        selectAtIndex: function (index) {
            openSelection();
            var elem = optionAtIndex(index).elem;
            Simulate.mouseDown(elem);
        },
        getSelectionTitles: function () {
            openSelection();
            return baseDriver.findAll('.Select-option').map(function (e) { return e.getText(); });
        },
        selectByOptionClassName: function (className) {
            openSelection();
            var elem = baseDriver.find(".Select-option." + className).elem;
            Simulate.mouseDown(elem);
        },
        getSelectedValues: function () { return baseDriver.findAll('.Select-value-label').map(function (i) { return i.getText().replace(/\s$/g, ''); }); }
    };
};
export var createMultiSelect = function (props) {
    var elem = renderAndMountComponent(React.createElement(DeprecatedMultiSelect, __assign({}, props)));
    return createMultiSelectLegacyDriver(elem);
};
//# sourceMappingURL=multi-select.legacy-driver.js.map